import React, { Component } from 'react'
import axios from 'axios'

import ContentHeader from '../../common/template/ContentHeader'
import Content from '../../common/template/Content'
import Row from '../../common/layout/row'
import Grid from '../../common/layout/grid'
import { APP_NAME } from '../config'

export default class Pricing extends Component {
  constructor(props) {
    super(props)
    this.state = { prices: [], msg: '', saving: false }
  }

  componentDidMount() {
    document.title = 'Preços · ' + APP_NAME
    this.load()
  }

  load = async () => {
    try {
      const res = await axios.get(`${window.API_URL || ''}/api/privzap/billing-prices`)
      const rows = (res.data && (res.data.data || res.data)) || []
      this.setState({ prices: Array.isArray(rows) ? rows : [], msg: '' })
    } catch (e) {
      this.setState({ msg: 'Falha ao carregar preços' })
    }
  }

  onChange = (key, field, value) => {
    this.setState({
      prices: this.state.prices.map(p => p.key === key ? { ...p, [field]: value } : p),
    })
  }

  save = async () => {
    this.setState({ saving: true, msg: '' })
    try {
      await axios.put(`${window.API_URL || ''}/api/privzap/billing-prices`, {
        prices: this.state.prices.map(p => ({
          key: p.key,
          cents: parseInt(p.cents, 10) || 0,
          label: p.label,
        })),
      })
      this.setState({ msg: 'Salvo', saving: false })
      this.load()
    } catch (e) {
      this.setState({ msg: 'Falha ao salvar', saving: false })
    }
  }

  render() {
    const { prices, msg, saving } = this.state
    return (
      <div>
        <ContentHeader title="Preços" small="Fonte da verdade dos serviços cobrados" />
        <Content>
          <Row>
            <Grid cols="12">
              <p style={{ color: '#666' }}>Valores em centavos (BRL). O surge de ocupação aplica-se em runtime só a nova conversa e mensagem enviada.</p>
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Chave</th>
                    <th>Rótulo</th>
                    <th>Centavos</th>
                  </tr>
                </thead>
                <tbody>
                  {prices.map(p => (
                    <tr key={p.key}>
                      <td><code>{p.key}</code></td>
                      <td>
                        <input
                          className="form-control"
                          value={p.label || ''}
                          onChange={e => this.onChange(p.key, 'label', e.target.value)}
                        />
                      </td>
                      <td style={{ maxWidth: 140 }}>
                        <input
                          className="form-control"
                          type="number"
                          min="0"
                          value={p.cents}
                          onChange={e => this.onChange(p.key, 'cents', e.target.value)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <button className="btn btn-primary" disabled={saving} onClick={this.save}>
                {saving ? 'Salvando…' : 'Salvar'}
              </button>
              {msg ? <span style={{ marginLeft: 12 }}>{msg}</span> : null}
            </Grid>
          </Row>
        </Content>
      </div>
    )
  }
}
